var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41562 10.255L6.57224 14.9306L10.7289 10.255C13.9169 6.66893 11.3709 1 6.57224 1C1.77363 1 -0.772405 6.66893 2.41562 10.255Z",
    stroke: "#863CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57202 8.66161C7.72607 8.66161 8.66161 7.72607 8.66161 6.57202C8.66161 5.41796 7.72607 4.48242 6.57202 4.48242C5.41796 4.48242 4.48242 5.41796 4.48242 6.57202C4.48242 7.72607 5.41796 8.66161 6.57202 8.66161Z",
    stroke: "#863CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location_pin.432157881ff497b09af8f252a66e6a26.svg";
export { ForwardRef as ReactComponent };